import { FC, ReactElement } from 'react';

import classNames from 'classnames';

import { LinkButton, Picture, SafeHtml } from '../../../../../components';
import { VisualCarouselSlideInterface } from '../../../../../entities/@sections/VisualCarousel/VisualCarousel';
import useResponsiveImages from '../../../../../hooks/useResponsiveImages';

import './FullWidthVisualCarouselSlide.scss';

export interface FullWidthVisualCarouselSlideProps extends VisualCarouselSlideInterface {
    hasFixedTitle: boolean;
    className?: string;
}

const FullWidthVisualCarouselSlide: FC<FullWidthVisualCarouselSlideProps> = ({
    hasFixedTitle,
    title,
    intro,
    paragraphHtml,
    links,
    image,
    responsiveImages,
    align,
    className = '',
}): ReactElement => {
    const imageList = image ? [image] : [];
    const responsiveImageList = useResponsiveImages(imageList, responsiveImages);

    const slideImage = responsiveImageList.length > 0
        ? responsiveImageList[0]
        : undefined;

    const slideClassNames = classNames('full-width-visual-carousel-slide', {
        'full-width-visual-carousel-slide--has-fixed-title': hasFixedTitle,
        [`full-width-visual-carousel-slide--align-${align}`]: align,
    }, className);

    return (
        <div className={slideClassNames}>
            <div className="full-width-visual-carousel-slide__text-wrapper">
                {!hasFixedTitle && (
                    <h2 className="full-width-visual-carousel-slide__title">
                        {title}
                    </h2>
                )}

                {intro && (
                    <h3 className="full-width-visual-carousel-slide__intro">
                        {intro}
                    </h3>
                )}

                <SafeHtml
                    html={paragraphHtml}
                    className="full-width-visual-carousel-slide__description"
                />

                {links.length > 0 && (
                    <div className="full-width-visual-carousel-slide__link-button-wrapper">
                        {links.map(link => (
                            <LinkButton
                                key={link.path}
                                text={link.label}
                                to={link.path}
                                className="full-width-visual-carousel-slide__link-button"
                            />
                        ))}
                    </div>
                )}
            </div>

            {slideImage && (
                <Picture
                    {...slideImage.image}
                    objectPosition={slideImage.position}
                    className="full-width-visual-carousel-slide__picture"
                    imageClassName="full-width-visual-carousel-slide__image"
                />
            )}
        </div>
    );
};

export default FullWidthVisualCarouselSlide;
